import createTheme from '../../stories/theme/helpers/createTheme';
import { defaultThemeOptions } from '../../stories/theme/defaultTheme';

// eslint-disable-next-line import/prefer-default-export
export const cafmTheme = createTheme({ ...defaultThemeOptions });
